import { render, staticRenderFns } from "./BenefitsList.vue?vue&type=template&id=39a06c9e&scoped=true&"
import script from "./BenefitsList.vue?vue&type=script&lang=js&"
export * from "./BenefitsList.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsList.vue?vue&type=style&index=0&id=39a06c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a06c9e",
  null
  
)

export default component.exports